import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

import { Button } from '../../components/ui/button';
import { LoanReviewDetails } from '../../components/common/LoanReviewModal';

export default function LoanDetailsPage() {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div className="space-y-4">
      <Button variant="ghost" className="gap-2" onClick={() => navigate(-1)}>
        <ArrowLeft className="h-4 w-4" />
        Back to Loans
      </Button>

      <LoanReviewDetails loanId={id} showFooter={false} />
    </div>
  );
}
